import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface Props {
    content: string | React.ReactNode
    placement?: 'top' | 'bottom' | 'left' | 'right'
    className?: string
    label?: string
}

export default function InfoTooltip({ content, placement = 'top', className = '', label }: Props) {
    const tooltipContent = typeof content === 'string' && content.includes('\n')
        ? content.split('\n').map((line, index) => (
            <div key={index}>{line}</div>
        ))
        : content;

    const infoIcon = (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip>
                    {tooltipContent}
                </Tooltip>
            }
        >
            <i className={`bi bi-info-circle text-muted ${label ? '' : 'ms-1'} ${className}`} style={{ cursor: 'pointer' }} />
        </OverlayTrigger>
    );

    if (label) {
        return (
            <div className="d-flex align-items-center gap-1">
                <span>{label}</span>
                {infoIcon}
            </div>
        );
    }

    return infoIcon;
}